module.exports = __webpack_public_path__ + "img/image_lila5.77874c30.jpg";